import {sprintf} from '@/angular/libs/sprintf';
import {mergeGraph, registerGraph} from '@/angular/modules/vrm-graph/config-utils';
import getCssVariable from '@/utils/css_properties';

registerGraph('historicPieGraph', historicPieGraph);

/* @ngInject */
function historicPieGraph(GraphService, defaultGraph) {
    const GraphColors = GraphService.colors;

    let defaultSize = getCssVariable('--height-historic-pie-chart', 160);

    return mergeGraph(defaultGraph(), {
        options: {
            chart: {
                marginTop: 10,
                spacingBottom: 10,
                events: {
                    render: function () {
                        // Center the title inside the donut chart (to account for legend)
                        const seriesElPos = this.seriesGroup.getBBox();
                        this.title.attr({
                            x: seriesElPos.width / 2 + seriesElPos.x
                        });
                    }
                },
            },
            tooltip: {
                enabled: true,
                formatter: function () {
                    return sprintf('<b>%.2f kWh</b>', this.y)
                }
            },
            title: {
                text: '',
                align: 'center',
                verticalAlign: 'middle',
                y: 5,
                style: {
                    fontSize: 12,
                    color: '#969591',
                    fontWeight: 100
                }
            },
            plotOptions: {
                pie: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true,
                    point: {
                        events: {
                            legendItemClick: function () {
                                return false;
                            }
                        }
                    }
                }
            },
        },
        series: [{
            type: 'pie',
            innerSize: '66%',
            visible: false,
            data: [],
            states: {
                hover: {
                    enabled: false
                }
            }
        }],
        size: {
            width: defaultSize,
            height: defaultSize,
        }
    });
}
